import { createApp } from 'vue';
import TarGzToZipConverter from '@/Components/TarGzToZipConverter.vue';
import '@styles/app.css';

createApp(TarGzToZipConverter).mount('#tar-gz-to-zip-converter');
